import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../../languages/i18n';

export default function ClinicianDetailsView({ clinicianData }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label='user details table'>
        <TableBody>
          <TableRow>
            <TableCell><strong>{translations['_username']}</strong></TableCell>
            <TableCell align='left'>{clinicianData.username}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>{translations['_firstName']}</strong></TableCell>
            <TableCell align='left'>{clinicianData.firstName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>{translations['_lastName']}</strong></TableCell>
            <TableCell align='left'>{clinicianData.lastName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>{translations['_email']}</strong></TableCell>
            <TableCell align='left'>{clinicianData.email}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// Indica i controla els props que se han de passar al component
ClinicianDetailsView.propTypes = {
  clinicianData: PropTypes.object.isRequired,
};
